import { createContext as o } from "react";
const n = o({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
export {
  n as MotionConfigContext
};
